<template>
  <div class="tw-relative">
    <quarantine-common
      v-if="selectedCustomer"
      :tier="tierType"
      :tier_id="selectedCustomer.id"
      class="tw-mb-6"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import QuarantineCommon from "@/views/Common/Quarantine";

import { TIER } from "@/constants";

export default {
  components: {
    QuarantineCommon,
  },
  data() {
    return {
      tierType: TIER.domainGroups,
    };
  },
  computed: {
    ...mapGetters("authentication", ["selectedCustomer"]),
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  mounted() {
    this.setPageTitle(this.$t("Quarantine"));
    if (!this.selectedCustomer) {
      this.$router.push("/logout");
    }
  },
};
</script>
